import { ERRORS_CLEARED, ERRORS_UPDATED } from '../actions/errors';

export function errors(state = {}, action) {
    switch (action.type) {
        case ERRORS_UPDATED:
            return { ...state, ...action.payload };
        case ERRORS_CLEARED:
            return {};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/incab/common/reducers/errors.js